import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPng = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.2367 13.0485C9.2367 13.398 9.13185 13.6776 8.92216 13.8524C8.71247 14.0271 8.39794 14.1319 7.97856 14.1319H7.69897V15.2852H7V12.035H8.04845C8.43288 12.035 8.74742 12.1049 8.95711 12.2797C9.1668 12.4544 9.2367 12.734 9.2367 13.0485ZM7.69897 13.5728H7.90866C8.11835 13.5728 8.29309 13.5378 8.39794 13.433C8.50278 13.3631 8.57268 13.2233 8.57268 13.0835C8.57268 12.9087 8.53773 12.8039 8.43288 12.734C8.32804 12.6641 8.22319 12.6292 8.0135 12.6292H7.69897V13.5728V13.5728Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8343 15.2852H11.9606L10.5627 12.8388H10.5277C10.5627 13.2582 10.5627 13.5728 10.5627 13.7825V15.2852H9.93359V12.035H10.8073L12.2052 14.4814C12.1703 14.062 12.1703 13.7475 12.1703 13.5728V12.035H12.7994V15.2852H12.8343Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9675 13.4678H16.2606V15.1454C16.0509 15.2153 15.8412 15.2502 15.6664 15.2851C15.4917 15.3201 15.282 15.3201 15.1073 15.3201C14.618 15.3201 14.2336 15.1803 13.9889 14.9007C13.7443 14.6211 13.6045 14.2018 13.6045 13.6775C13.6045 13.1533 13.7443 12.7339 14.0588 12.4543C14.3734 12.1747 14.7578 12 15.317 12C15.6664 12 15.981 12.0699 16.2955 12.2097L16.0509 12.7689C15.8062 12.664 15.5616 12.5941 15.317 12.5941C15.0024 12.5941 14.7927 12.699 14.618 12.9087C14.4433 13.1183 14.3384 13.363 14.3384 13.7125C14.3384 14.062 14.4083 14.3415 14.5481 14.5163C14.6879 14.691 14.8976 14.7959 15.1772 14.7959C15.317 14.7959 15.4568 14.7959 15.6315 14.7609V14.0969H15.0024V13.4678H14.9675Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0996 3V7.8H18.8996",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9 17V8.21421C18.9 7.949 18.7946 7.69464 18.6071 7.50711L14.3929 3.29289C14.2054 3.10536 13.951 3 13.6858 3H5.5C4.94771 3 4.5 3.44772 4.5 4V17",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 18.3V20C4.5 20.5523 4.94772 21 5.5 21H17.9C18.4523 21 18.9 20.5523 18.9 20V18.3",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
export default SvgPng;
